import React, { useCallback, useEffect, useRef, useState } from 'react'
import { features } from '../data-renderer/WhatMakesData'
import { IndicatorsSvg } from '../../../components/WhatMakesSvg';

function WhatMakesMobile() {
    const scrollContainer = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleScroll = useCallback(() => {
        const { current } = scrollContainer;
        if (current) {
            const scrollPosition = current.scrollLeft;
            const itemWidth = current.offsetWidth;
            const newIndex = Math.round(scrollPosition / itemWidth);
            setActiveIndex(newIndex);
        }
    }, []);

    useEffect(() => {
        const { current } = scrollContainer;
        if (current) {
            current.addEventListener('scroll', handleScroll);
            return () => current.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll]);

    const scrollToIndex = (index) => {
        const { current } = scrollContainer;
        if (current) {
            const itemWidth = current.offsetWidth;
            current.scrollTo({
                left: index * itemWidth,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="block md:hidden px-6 py-20 w-full relative">
            <h1 className="text-[40px] leading-[54px] font-semibold text-center mb-6 lg:mb-10 text-[#27506E]">
                What Makes Us Different
            </h1>
            <div className="flex flex-col items-center justify-center">
                <div
                    ref={scrollContainer}
                    className="flex overflow-x-auto w-full no-scrollbar scroll-smooth"
                    style={{
                        scrollSnapType: 'x mandatory',
                        scrollBehavior: 'smooth',
                        WebkitOverflowScrolling: 'touch',
                    }}
                >
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className='flex-shrink-0 w-full flex flex-col border border-[#DADADA] rounded-3xl p-6'
                            style={{
                                scrollSnapAlign: 'start'
                            }}
                        >
                            <div className='flex items-center flex-row justify-between'>
                                <img src={feature.leftImage} alt={feature.title} />
                                <feature.RightSvg className='fill-[#B7E1FC] transition-colors duration-300' />
                            </div>
                            <p className='text-base leading-[26px] font-medium text-[#181818]'>{feature.title}</p>
                            <p className='text-base leading-[26px] font-normal text-[#181818] opacity-70'>{feature.description}</p>
                        </div>
                    ))}
                </div>
                <div className='flex flex-row items-center justify-center gap-2 mt-6'>
                    {features.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => scrollToIndex(i)}
                            aria-label={`Go to slide ${i + 1}`}
                            aria-current={i === activeIndex ? "true" : "false"}
                        >
                            <IndicatorsSvg fill={i === activeIndex ? '#0B497A' : '#CEDBE4'} />
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default WhatMakesMobile